import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const notFoundImgs = ['/cats/hungry.png', '/cats/facepalm.apng', '/cats/cage.png'];
const _notFoundImg = notFoundImgs[Math.floor(Math.random() * notFoundImgs.length)];

const Page404: React.FC = () => {
    const location = useLocation();

    useEffect(() => {
        document.title = '404 Not Found - FileVault';
        document.getElementsByClassName('ui-loader-container')[0]?.remove();
    }, []);

    return (
        <div className="not-found-page">
            <div className="not-found-card">
                <img src={_notFoundImg} alt="Cat illustration" className="not-found-illustration" />
                <div className="not-found-code">404</div>
                <h1>Page not found</h1>
                <p>
                    The page <span className="not-found-path">{location.pathname}</span> does not exist or was moved.
                </p>
                <div className="not-found-actions">
                    <Link to="/" className="btn btn-primary">Take me home</Link>
                    <button className="btn btn-secondary" onClick={() => window.history.back()}>Go back</button>
                </div>
            </div>
        </div>
    );
};

export default Page404;